import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const entityContentPulseInsights: ExtensionDefinition =
  EntityContentBlueprint.make({
    name: 'pulse-insights',
    params: {
      path: '/pulse-insights',
      title: 'Pulse Insights',
      filter: { kind: 'Group' },
      loader: async () =>
        import('./group-insights-content').then(m => (
          <m.GroupInsightsContent />
        )),
    },
  });
